import React from "react";
import PropTypes from "prop-types";
import Modal from "../../../components/ui-components/Modal";

const SourceConflictModal = ({ open, conflict, onOpenConflict, onAdjust }) => {
  const name = conflict?.display_name || "another source";
  return (
    <Modal
      show={open}
      close={onAdjust}
      title="This selection is already taken"
      description={
        <span>
          The source <strong>"{name}"</strong> already matches this exact set of values.
          Two sources can't claim the same selection.
        </span>
      }
      confirmButton={`Open "${name}"`}
      confirmAction={onOpenConflict}
      cancelButton="Adjust this selection"
      alertIcon
    />
  );
};

SourceConflictModal.propTypes = {
  open: PropTypes.bool.isRequired,
  conflict: PropTypes.shape({ id: PropTypes.number, display_name: PropTypes.string }),
  onOpenConflict: PropTypes.func.isRequired,
  onAdjust: PropTypes.func.isRequired,
};

export default SourceConflictModal;
